// extracted by mini-css-extract-plugin
export default {"root":"questionnaire_root__oq405","skeleton":"questionnaire_skeleton__FEFrq"};